<template>
	<div class="navigation">
		<div class="menu-panel">
			<div class="menu">
				<div class="btn"  v-for="(item,index) in btns" :key="index"  :class="{btnActive:activeIndex ==index}" @click="btnClick(item,index)">
                    <img src="img/btn1_1.png"/>
					{{item.name}}
                    <img src="img/btn1_2.png"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name:"navigation",
		props:{
		},
		data() {
			return {
				btns:[{
					name:"首页",
					target:"/home"
				},
				{
					name:"申请书",
					target:"/application_form"
				},
				{
					name:"团队介绍",
					target:"/team_introduce"
				},
				{
					name:"获奖情况",
					target:"/awards_condition"
				},
				{
					name:"多维实践平台",
					target:"/practice_platform"
				},
				{
					name:"支撑材料",
					target:"/support_materials"
				},
				{
					name:"应用推广",
					target:"/application_promotion"
				},
				{
					name:"成果总结",
					target:"/achievement_summarize",
				}],
				activeIndex:0
			};
		},
		methods:{
			btnClick(item,index){
				this.activeIndex = index;
                this.$router.push({path:item.target})
			}
		},
		created(){
			this.activeIndex = this.index;
		},
		computed:{
			index(){
				let mIndex = 0;
				switch(this.$route.path){
					case "/home":
						mIndex = 0;
						break;
					case "/application_form":
						mIndex = 1;
						break;
					case "/team_introduce":
						mIndex = 2;
						break;
					case "/awards_condition":
						mIndex = 3;
						break;
					case "/practice_platform":
						mIndex = 4;
						break;
					case "/support_materials":
						mIndex = 5;
						break;
					case "/application_promotion":
						mIndex = 6;
						break;
					case "/achievement_summarize":
						mIndex = 7;
						break;
				}
				return mIndex;
			}
		}
	}
</script>



<style lang="scss" scoped>
	.navigation{
		width: 100%;
		margin-top: 4px;
		height: 54px;
		background-color: #016285;
		display: flex;
		justify-content: center;
		.menu-panel{
			width: 1200px;
			overflow: hidden;
			.menu{
				width: 1200px;
				height: 100%;
				display: flex;
				white-space: nowrap;
				overflow: hidden;
				
				.btn{
					flex: 1;
					height: 100%;
					line-height: 54px;
					text-align: center;
					color: #B9CAE1;
					font-weight: 600;
					font-size: 2ch;
					
					border-left: 1px #F3F3F3 solid;
					border-right: 1px #F3F3F3 solid;
					
					display: flex;
					justify-content: space-between;
					align-items:center;
					
					
					img{
						height: 24px;
						margin: 0 6px;
						opacity: 0.6;
					}
				}
				.btn:first-child{
					border-left: 2px #F3F3F3 solid;
				}
				.btn:last-child{
					border-right: 2px #F3F3F3 solid;
				}
				
				.btn:hover{
					color: white;
					background-color: #053F53;
					cursor: pointer;
					img{
						height: 24px;
						opacity: 1;
					}
				}
				.btnActive{
					color: white;
					background-color: #053F53;
					
					img{
						height: 24px;
						opacity: 1;
					}
				}
			}
		}

	}

</style>